import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import { InlineGridField, InlineGrid, UploaderField, Uploader } from '@components/form';
import { repairsInvoicesColumns } from '@modules/repairs/_repairsColumns';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

const View: React.SFC<any> = ({ disabled }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={12}>
          <Row>
            <Col md={12}>
              <InlineGridField
                component={InlineGrid}
                ActionBar={() =>
                  !disabled ? (
                    <div style={{ marginLeft: 5 }}>
                      <UploaderField component={Uploader} name="invoices" url="/metropolis/api/files/">
                        <Button primary={true}>
                          <span
                            style={{
                              color: 'white',
                              textTransform: 'uppercase'
                            }}
                          >
                            Přidat
                          </span>
                        </Button>
                      </UploaderField>
                    </div>
                  ) : null
                }
                name="invoices"
                columns={repairsInvoicesColumns}
                showCheckboxes={!disabled}
                editing={false}
                deleting={!disabled}
                adding={false}
                filtering={false}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Grid>
    <Divider />
  </div>
);
export const RepairsInvoicesForm = View;



// WEBPACK FOOTER //
// ./src/modules/repairs/RepairsInvoicesForm.tsx